import React from 'react';
import styles from './styles.module.scss';

const RequiredStar = () => <span className={styles.requiredStar}>*</span>;

export default RequiredStar;
